module.exports = __webpack_public_path__ + "img/64.4502e47c.jpg";